import { supabase } from "src/lib/supabaseClient";

export interface BookingDomain {
  id: string;
  name: string;
}

export interface BookingUnit {
  id: string;
  name: string;
}

export interface BookingObjective {
  id: string;
  title: string;
  learningObjective: string;
  unitId?: string;
}

const call = async <T>(name: string, args: Record<string, string> = {}): Promise<T[]> => {
  const { data, error } = await supabase.rpc(name, args);
  if (error) throw new Error(error.message);
  return (data || []) as T[];
};

export const studentBookingCurriculumService = {
  listDomains: (batchId: string) => call<BookingDomain>("get_booking_curriculum_domains", { p_batch_id: batchId }),
  listUnits: (batchId: string, domainId: string) => call<BookingUnit>("get_booking_curriculum_units", { p_batch_id: batchId, p_domain_id: domainId }),
  listObjectives: (batchId: string, unitId: string) => call<BookingObjective>("get_booking_curriculum_objectives", { p_batch_id: batchId, p_unit_id: unitId }),
};
